<template>
    <div>
        <div class="issue-cover">
            <img :src="img_src">
            <popper
                v-for="(location, i) in locations"
                v-bind:key="i"
                class="issue-cover__marker"
                :style="markerStyle(location)"
                trigger="clickToOpen"
                boundariesSelector="body"
                :options="{placement: 'top'}"
                @documentClick="documentClicked"
                @show="selectMarker($event)">
                <div class="popper" v-html="locationDescription(location)"></div>
                <i slot="reference" class="icon-ok-map-marker-solid icon-ok-map-marker-solid--travel"><span class="path2"></span><span class="path3"></span></i>
            </popper>
        </div>
    </div>
</template>

<script>
    import Popper from 'vue-popperjs';
    import 'vue-popperjs/dist/vue-popper.css';

    export default {
        name: 'InteractiveIssueCover',
        props: {
            'img_src': {
                type: String,
                required: true
            },
            'locations': {
                type: Array,
                required: true
            }
        },
        data() {
            return {};
        },
        components: {
            'popper': Popper
        },
        methods: {
            locationDescription(location) {
                return `<h4 class="issue-cover__marker-name">${location.name}</h4><h5 class="issue-cover__marker-address">${location.address}</h5><p>${location.description}</p>`;
            },
            markerStyle(location) {
                return {
                    'left': 'calc(' + location.left + ' - 2rem)',
                    'top': 'calc(' + location.top + ' - 4rem)',
                };
            },
            selectMarker(event) {
                event.$el.classList.add("active");
            },
            documentClicked(event) {
                event.$el.classList.remove('active');
            }
        },
    };
</script>
